// The one place the backend URL is decided. Opened on this machine, the app
// talks to the local backend; deployed, it talks to production. Nothing to
// toggle by hand, so a local URL can never be committed by accident.
const LOCAL_HOSTS = ["localhost", "127.0.0.1"];

export const API_URL = LOCAL_HOSTS.includes(window.location.hostname)
  ? "http://localhost:4000"
  : "https://docapi.campuscare.cloud";

export const getHeaders = () => {
  const token = localStorage.getItem("token");

  return {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  };
};
